export default "__VITE_ASSET__CvjHQLj$__"